import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { t } from 'state/intl/translations';
import type { TranslationKey } from 'state/intl/types';

/** ICU templates — defaults when keys are not yet in the locale bundle (managed elsewhere). */
const LOYALTY_SWAP_REWARD_TITLE_DEFAULT =
  '{maxRewards, plural, one {One reward per order} other {Up to # rewards per order}}';

const LOYALTY_SWAP_REWARD_BODY_DEFAULT =
  '{appliedRewards, plural, one {Your cart already has # reward.} other {Your cart already has # rewards.}} Swap one out to add this reward?';

type LoyaltyIncentiveSwapDialogRewardProps = {
  incentiveType: LoyaltyPromotionType.REWARD;
  maxRewards: number;
  appliedRewards: number;
};

type LoyaltyIncentiveSwapDialogNonRewardProps = {
  incentiveType: Exclude<LoyaltyPromotionType, LoyaltyPromotionType.REWARD>;
};

export type LoyaltyIncentiveSwapDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onSwap: () => void;
  onAfterClose?: () => void;
} & (LoyaltyIncentiveSwapDialogRewardProps | LoyaltyIncentiveSwapDialogNonRewardProps);

export const LoyaltyIncentiveSwapDialog = (props: LoyaltyIncentiveSwapDialogProps) => {
  const { isOpen, onClose, onSwap, onAfterClose, incentiveType } = props;
  const isReward = incentiveType === LoyaltyPromotionType.REWARD;

  const heading = isReward
    ? t('loyaltySwapRewardTitle', {
        defaultValue: LOYALTY_SWAP_REWARD_TITLE_DEFAULT,
        maxRewards: props.maxRewards,
      })
    : t('oneOfferPerOrder', 'Only one offer per order');

  const body = isReward
    ? t('loyaltySwapRewardBody', {
        defaultValue: LOYALTY_SWAP_REWARD_BODY_DEFAULT,
        appliedRewards: props.appliedRewards,
      })
    : t('swapOfferText', 'Would you like to replace the offer already in your cart?');

  return (
    <Dialog
      showDialog={isOpen}
      heading={heading}
      body={body}
      showCloseButton
      onDismiss={onClose}
      onAfterClose={onAfterClose}
      closeButtonLabelId={'keepCurrent' as TranslationKey}
      closeButtonDefaultMessage="Keep Current"
      actions={
        <ActionButton onPress={onSwap} fullWidth={true} testID="dialog-confirm-btn">
          {isReward ? t('swapReward', 'Swap reward') : t('replace', 'Replace')}
        </ActionButton>
      }
      modalAppearanceEventMessage={''}
    />
  );
};
